import Wallet from "../pages/wallet/Wallet";
import StudentWalletTopup from "../pages/wallet/StudentWalletTopup";

function WalletRoutes (){
    return [
        {
            'path': '/wallet',
            'element': <Wallet />
        },
        {
            'path': '/wallet/student-topup',
            'element': <StudentWalletTopup />
        },
    ];
}

export default WalletRoutes;